import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "./Inner_Activity_Card.css";

function Inner_Activity_Card({
  item,
  icons,
  mainImage,
  changeMainImage,
  // index,
  // hideImages = false,
}) {
  const [activeMeal, setActiveMeal] = useState("breakfast");
  return (
    <div className="itinerary_card">
      <div className="day_card">
        <div className="">
          <img
             src={mainImage || item?.images?.[0]?.image}
            className="hotel_main_img"
            alt="hotel"
          />

          <Swiper
            spaceBetween={10}
            breakpoints={{
              0: { slidesPerView: 4 },
              576: { slidesPerView: 6 },
              768: { slidesPerView: 5 },
              992: { slidesPerView: 6 },
              1024: { slidesPerView: 7 },
            }}
          >
            {item?.images?.map((img, i) => (
              <SwiperSlide key={i}>
                <img
                  src={img?.image}
                  className="thumbImg"
                  alt=""
                       onClick={() => changeMainImage(img?.image)}
                />
              </SwiperSlide>
            ))}
          </Swiper>

          {!item && (
            <div className="inclusion_wrapper">
              <div className="inclusion_card">
                <div className="inclusion_left">
                  <h6>Standard</h6>
                  <p>Inclusions:</p>
                </div>

                <div className="inclusion_items">
                  <div
                    className={`inclusion_item ${
                      activeMeal === "breakfast" ? "active" : ""
                    }`}
                    onClick={() => setActiveMeal("breakfast")}
                  >
                    <div className="img_holder">
                      <img
                        src="/assets/images/icons/img1.png"
                        className="inner_img"
                      />
                    </div>
                    <p className="inner_text">Breakfast</p>
                    <span className="inner_text">Included</span>
                  </div>

                  <div className="inclusion_divider"></div>

                  <div
                    className={`inclusion_item ${
                      activeMeal === "lunch" ? "active" : ""
                    }`}
                    onClick={() => setActiveMeal("lunch")}
                  >
                    <div className="img_holder">
                      <img
                        src="/assets/images/icons/img2.png"
                        className="inner_img"
                      />
                    </div>
                    <p className="inner_text">Lunch</p>
                    <span className="inner_text">Not Included</span>
                  </div>

                  <div className="inclusion_divider"></div>

                  <div
                    className={`inclusion_item ${
                      activeMeal === "dinner" ? "active" : ""
                    }`}
                    onClick={() => setActiveMeal("dinner")}
                  >
                    <div className="img_holder">
                      <img
                        src="/assets/images/icons/img3.png"
                        className="inner_img"
                      />
                    </div>
                    <p className="inner_text">Dinner</p>
                    <span className="inner_text">Not Included</span>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default Inner_Activity_Card;
